// extracted by mini-css-extract-plugin
module.exports = {"root":"_a33f5c","content":"_62a6cc"};